import certificatesReducer from "./CertificatesReducer"
export default certificatesReducer